import "./processSlider.scss";
import SlickSliderComponent from "../slickslider/slickslider.cmp";

class ProcessSliderComponent extends SlickSliderComponent {

    /**
     * Default constructor
     * @param {string} selector Selector component the component
     * @param {string} innerSelector Inner selector of slick slider containers
     */
    constructor(selector, innerSelector) {
        super(selector, innerSelector, false);

        this.slideElementSelector = ".process-slider-element";
        this.windowSizes = {
            mobile: 768,
            tablet: 1024
        };

        if (document.querySelectorAll(selector) != null && document.querySelectorAll(selector).length > 0) {
            $(window).on("load", this.windowResize());
            $(window).on("resize", this.windowResize());
        }
    }

    /**
     * Returns the window resize event.
     * @returns {Function} The window resize event
     */
    windowResize() {
        var that = this;

        return function () {
            that.disableSliders();
            that.initSliders();
            that.setPagination();
        };
    }

    /**
     * Returns the slide count per viewport.
     */
    getElementsPerSlideCount() {
        var windowWidth = $(window).width();

        if (windowWidth < this.windowSizes.mobile) {
            return 1;
        } else if (windowWidth < this.windowSizes.tablet) {
            return 2;
        } else {
            return 4;
        }
    }

    /**
     * Sets equal height for all slide elements.
     */
    setEqualHeight() {
        var $sliders = this.getSliders();

        $sliders.each(function () {
            var $textboxes = $(this).find(".process-slider-element__textbox");
            var textboxGreatestHeight = 0;

            $textboxes.each(function () {
                $(this).height("auto");
                var currentHeight = $(this).height();
                textboxGreatestHeight = currentHeight > textboxGreatestHeight ? currentHeight : textboxGreatestHeight;
            });

            $textboxes.each(function () {
                $(this).height(textboxGreatestHeight);
            });
        });
    }

    /**
     * Append slide elements into temporary div containers
     * to pair them with different count for each viewport.
     */
    rearrangeSlides() {
        var that = this;
        var $sliders = this.getSliders();
        var elementsPerSlide = this.getElementsPerSlideCount();

        $sliders.each(function () {
            var $this = $(this);
            var $slider = $this.find(that.defaultSliderInnerSelector);
            var $slideElements = $this.find(that.slideElementSelector);
            var $slidesContainer = $("<div></div>");

            $slideElements.each(function (index) {
                var $slideElement = $(this);
                var $clonedSlideElement = $slideElement.clone();
                $clonedSlideElement.appendTo($slidesContainer);
                $slideElement.remove();

                if (elementsPerSlide == 1
                    || (index > 0 && (index + 1) % elementsPerSlide == 0)
                    || (index + 1) == $slideElements.length) {
                    $slider.append($slidesContainer);
                    $slidesContainer = $("<div></div>");
                }
            });

            $slider.children().each(function () {
                if ($(this).html().trim().length == 0) {
                    $(this).remove();
                }
            });
        });
    }

    /**
     * Hides/shows the pagination dependent on the pagecount and the elements slide count.
     */
    setPaginationVisibility() {
        var that = this;
        var $sliders = this.getSliders();
        var elementsPerSlide = this.getElementsPerSlideCount();

        $sliders.each(function () {
            var $this = $(this);
            var $slideElements = $this.find(that.slideElementSelector);

            if ($slideElements.length > elementsPerSlide) {
                $this.find(".pagination").show();
            } else {
                $this.find(".pagination").hide();
            }
        });
    }

    /**
     * Returns the Slider instances.
     * @returns {JQuery} The Slider Instances
     */
    getSliders() {
        return $(this.defaultSliderSelector).not(".process-slider--expe");
    }

    setPagination() {
        var $sliders = $(this.defaultSliderSelector).not(".gallery-slider--expe");

        $sliders.each(function () {
            var $pagination = $(this).find(".pagination");

            if ($pagination.length == 0) {
                return;
            }

            var $pagingInfo = $(this).find(".pagingInfo");

            if ($pagingInfo.length == 0) {
                return;
            }

            if ($(window).width() > 768) {
                $pagingInfo.removeProp("right");
                $pagingInfo.removeClass("show");
            } else {
                $pagingInfo.addClass("show");
                $pagingInfo.css("right", "auto");
                $pagingInfo.css("right", ($(window).width() - 32) / 2);
            }
        });
    }

    /**
     * Initializes the slick sliders.
     * @param {JQuery} $sliders Sliders to initialize
     * @param {string} sliderInnerSelector Inner selector of slick slider containers
     */
    initSliders() {
        var $sliders = this.getSliders();
        this.rearrangeSlides();
        this.setPaginationVisibility();
        this.setEqualHeight();
        this.setPagination();
        super.initSliders($sliders, this.defaultSliderInnerSelector);
    }

    /**
     * Disables the slick sliders.
     * @param {JQuery} $sliders Sliders to initialize
     * @param {string} sliderInnerSelector Inner selector of slick slider containers
     */
    disableSliders() {
        var $sliders = this.getSliders();
        super.disableSliders($sliders, this.defaultSliderInnerSelector);
    }
}

new ProcessSliderComponent(".process-slider", ".process-slider-inner");